import React from 'react';
import { Link } from 'react-router-dom';
import './Solutions.css';

const Solutions = () => {
  return (
    <div className="solutions-page">
      {/* Hero Section */}
      <section className="solutions-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Solutions by sector</h1>
            <p className="hero-subtitle">
              The same core platform, tailored to the realities of your work.
            </p>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="section">
        <div className="container">
          <div className="intro-content">
            <p className="intro-text">
              Pathway Labs is not a one-size-fits-all product. We adapt the platform to fit
              your sector, regulations, and day-to-day operations.
            </p>
          </div>
        </div>
      </section>

      {/* Nonprofits & Foundations */}
      <section className="section section-alt">
        <div className="container">
          <div className="solution-block">
            <h2>Nonprofits & Foundations</h2>
            <p className="solution-intro">
              You're juggling programs, funders, staff, and increasing expectations for transparency.
              We help by providing:
            </p>
            <ul className="solution-list">
              <li>Program and case management tools</li>
              <li>Grant and contract tracking</li>
              <li>Outcome and impact reporting</li>
              <li>Donor and partner visibility dashboards</li>
              <li>Compliance and audit support</li>
            </ul>
            <p className="solution-outcome">
              Your team gains time back. Your board and funders get clarity.
            </p>
          </div>
        </div>
      </section>

      {/* Education & Youth Programs */}
      <section className="section">
        <div className="container">
          <div className="solution-block">
            <h2>Education & Youth Programs</h2>
            <p className="solution-intro">
              Whether you run a school, after-school program, or youth-focused nonprofit,
              you need systems that are secure, respectful, and data-informed:
            </p>
            <ul className="solution-list">
              <li>Attendance and engagement tracking</li>
              <li>Curriculum and activity logging</li>
              <li>Progress and milestone dashboards</li>
              <li>Family communication workflows</li>
              <li>Privacy-aware data handling</li>
            </ul>
            <p className="solution-outcome">
              We design with young people and their safety at the center.
            </p>
          </div>
        </div>
      </section>

      {/* Social Impact Startups */}
      <section className="section section-alt">
        <div className="container">
          <div className="solution-block">
            <h2>Social Impact Startups</h2>
            <p className="solution-intro">
              You're moving fast, but you still need solid foundations. Pathway Labs can:
            </p>
            <ul className="solution-list">
              <li>Provide ready-made components for your MVP</li>
              <li>Handle sign-up, onboarding, and data storage</li>
              <li>Support role-based access and audit logs from day one</li>
              <li>Integrate with your existing stack (payments, messaging, analytics)</li>
            </ul>
            <p className="solution-outcome">
              You focus on product and users. We handle the infrastructure.
            </p>
          </div>
        </div>
      </section>

      {/* Mission-Aligned Capital */}
      <section className="section">
        <div className="container">
          <div className="solution-block">
            <h2>Mission-Aligned Capital & Family Offices</h2>
            <p className="solution-intro">
              If you're deploying capital into programs and organizations, you need visibility and governance:
            </p>
            <ul className="solution-list">
              <li>Performance and impact dashboards</li>
              <li>Program and grantee reporting pipelines</li>
              <li>Document management and evidence trails</li>
              <li>Governance workflows and approvals</li>
            </ul>
            <p className="solution-outcome">
              We help you see where capital is going and what it's producing over time.
            </p>
          </div>
        </div>
      </section>

      {/* Custom Engagements */}
      <section className="section custom-section">
        <div className="container">
          <div className="custom-content">
            <h2>Don't see your exact category?</h2>
            <p className="custom-text">
              Many of our most effective collaborations come from organizations working in complex
              or mixed environments—public/private partnerships, coalitions, and cross-sector initiatives.
            </p>
            <p className="custom-text">
              If your work doesn't fit in a neat box, we're probably a good fit.
            </p>
            <Link to="/contact" className="btn btn-primary btn-large">Talk to Our Team</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
